import { Typography } from '@mui/material'
import { Box } from '@mui/system'


import React, { Component } from 'react'
import "../../styles/components.css";

import wyzrTheme from '../../styles/customTheme';
export class FillBox extends Component {
    render() {
        return (
            <Box py={2} className="fillBox" borderRadius={2} boxShadow={3} sx={{ backgroundColor: this.props.id ? (this.props.id === this.props.env_id ? wyzrTheme.palette.primary.light : ""): "" }}>
                <Box className="fillColor" backgroundColor={wyzrTheme.palette.primary.light} position="absolute"
              bottom={0} left={0} zIndex={0} width="100%" height={`${this.props.saved/this.props.target *100}%`}></Box>

              <img src={this.props.image} alt={this.props.title} />

                <Typography variant="subtitle2"
                    fontWeight="800"
                    align="center"
                    zIndex={2}
                    gutterBottom sx={{ textTransform: "capitalize" }}>   
                        {this.props.category}
                </Typography>
                {
                    this.props.id ? null :
                    <>
                    <Typography variant="h4" zIndex={2} align="center">£ {this.props.saved}</Typography>
                <Typography variant="caption"
                color="text.secondary"
                fontWeight="700"
                align="center"
                zIndex={2}
                gutterBottom sx={{ textTransform: "lowercase" }}>   
                        out of £ {this.props.target}
                </Typography>
                </>
            }

            </Box>
        )
    }
}

export default FillBox
